import React, { useState } from 'react';
import { AreaSubIcon } from './AreaSubIcon.css.js';
import { FaMapMarkerAlt } from 'react-icons/fa';
import AreaDetail from './areaDetail/AreaDetail';

const ConfigArea = () => {
  const [ iconViewFlag, setIconViewFlag ] = useState(true);

  return (
    <>
      <AreaSubIcon>
        <div className={iconViewFlag ? 'on' : ''}>
          <FaMapMarkerAlt onClick={() => { setIconViewFlag(!iconViewFlag); }} />
        </div>
      </AreaSubIcon>
      <section>
        <AreaDetail iconViewFlag={iconViewFlag} setIconViewFlag={setIconViewFlag} />
      </section>
    </>
  )
}

export default ConfigArea;